import { pinMode } from '#packages/stateManagement';
import type { MapStateToProps } from 'types/redux';
import type { CSSProperties } from 'react';

export interface PinModeStateProps {
  pinPreviewRectStyle: CSSProperties;
}

export const mapStateToProps: MapStateToProps<PinModeStateProps, {}> = (
  stateMapperArgs,
) => {
  const { state } = stateMapperArgs;
  return {
    pinPreviewRectStyle: pinMode.selectors.getPinPreviewRectStyle(state),
  };
};
